import mutations from './finalExamination.mutations'
import actions from './finalExamination.actions'
import getters from './finalExamination.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
